'use client';

import React from 'react';

import { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { Separator } from '@eliadmin/core/src/components/ui/separator';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductTabsDescription({ product }: { product: ProductDetailData }) {
  const { t } = useTranslations();

  const selectedVariant = useVariantsStore(state => state.selectedVariant);
  const hasParameters = !!selectedVariant?.values?.length;

  //TODO: VALUES???

  return (
    <div className="flex w-full flex-col items-start justify-start gap-6 md:flex-row md:justify-between">
      <div className="flex w-full max-w-[690px] flex-col items-start justify-start gap-4 sm:gap-5 lg:gap-6">
        <Heading tag="h2" visualTag="h3" title={t('text231')} />
        <Paragraph
          className="w-full"
          color="foreground"
          innerHtml={selectedVariant?.description || product.description || ''}
          size="base"
        />
      </div>
      {hasParameters && (
        <div className="flex w-full flex-col items-start justify-start gap-3 rounded-[16px] border p-3 sm:p-4 md:max-w-[486px] lg:p-6">
          <Heading tag="h2" visualTag="h3" title={t('text9')} />
          {selectedVariant?.values?.map((value, index) => (
            <React.Fragment key={value.name}>
              <div className="flex w-full flex-col items-start justify-start gap-1">
                <Paragraph size="sm" color="neutral" className=" capitalize">
                  {value.attribute_name}:
                </Paragraph>
                <Paragraph size="base" color="foreground" className="font-semibold">
                  {value.name}
                </Paragraph>
              </div>
              <Separator
                className={cn({
                  hidden: index === (selectedVariant?.values?.length ?? 0) - 1,
                })}
              />
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}
